/**
 * Permission hooks — thin selectors over useAuthStore.
 *
 * These hooks subscribe to the minimum slice of the RBAC store needed for
 * each query, so components re-render only when the specific field changes.
 *
 * Usage:
 *   const canViewAnalytics = useHasPermission('VIEW_ANALYTICS');
 *   const isPartner = useIsPartner();
 */

import { useAuthStore } from './useAuthStore';

export function useHasPermission(code: string): boolean {
  return useAuthStore((s) => s.permissions.includes(code));
}

export function useIsPartner(): boolean {
  return useAuthStore((s) =>
    s.roles.some(
      (r) => r === 'PARTNER' || r === 'PARTNER_ADMIN' || r === 'PARTNER_STAFF',
    ),
  );
}

export function useIsAdmin(): boolean {
  return useAuthStore((s) => s.roles.includes('ADMIN'));
}

export function useIsAuthenticated(): boolean {
  return useAuthStore((s) => s.user !== null);
}

/** True once the first /auth/me round-trip is done. Use to avoid permission flicker. */
export function usePermissionsHydrated(): boolean {
  return useAuthStore((s) => s.hydrated);
}
